import mixin from '../function/mixin.js';

export default function mixinClass(a, b) {
  mixin(a, b, { ignoredProps: ['length', 'name', 'prototype'] });
  mixin(a.prototype, b.prototype, { ignoredProps: ['constructor'] });
}
